module.exports = __webpack_public_path__ + "img/trunk_8x1_z16.4aefba82.svg";